import { Box, Text } from '@chakra-ui/react'
import { BoldText } from 'ui'
import { useMediaQuery } from 'utils/src/helpers'

interface DetailPageHeaderDetailProps {
  detailHeading: string
  detail: string
  isLeadDetail?: boolean
  isDuration?: boolean
}

const DetailPageHeaderDetail = ({
  detailHeading,
  detail,
  isLeadDetail = false,
  isDuration
}: DetailPageHeaderDetailProps) => {
  const isDesktop = useMediaQuery('(min-width: 992px)')
  return detail ? (
    <Box
      paddingRight={isLeadDetail ? [5, 9, 9, 14] : []}
      borderRight={isLeadDetail ? '1px solid' : 'none'}
      borderRightColor={isLeadDetail ? 'deepblue.200' : 'unset'}
      sx={{
        'html[lang=ar] &': {
          paddingRight: 'unset',
          borderRight: 'unset',
          paddingLeft: isLeadDetail ? [5, 9, 9, 14] : [],
          borderLeft: isLeadDetail ? '1px solid' : 'none',
          borderLeftColor: isLeadDetail ? 'deepblue.200' : 'unset'
        }
      }}
    >
      <BoldText mb={0}>{detailHeading}</BoldText>
      <Text
        mb={0}
        whiteSpace={isDuration && isDesktop ? 'normal' : 'nowrap'}
      >
        {detail}
      </Text>
    </Box>
  ) : null
}

export default DetailPageHeaderDetail
